const excludedAuthPaths = ['/login', '/logout', '/otp/login', '/otp/redirect']

export default defineNuxtRouteMiddleware(async (_to: any, _from: any) => {
  const { isLoggedIn } = useUserStore()

  if (isLoggedIn) {
    await useUserSettingsStore().fetchUserSettings()
  } else if (!excludedAuthPaths.some((path) => _to.path.includes(path))) {
    return navigateTo('/login')
  }
})
